import './App.css';
import { Route, Routes } from 'react-router-dom';
import { ApplicationProtectedRouting, ApplicationPublicRouting } from './Routing';
import { ThemeProvider, createTheme } from '@mui/material';
import { ProtectedRouteAuth } from './components/protected/ProtectedRouteAuth';
import Constants from './utils/Constants';

const App = () => {
  
  const publicRoute = Object.entries(ApplicationPublicRouting).map(([key, value]) => {
    return (<Route key={key} path={value.path()} element={<value.element/>} />)
  });

  const privateRoute = Object.entries(ApplicationProtectedRouting).map(([key, value]) => {
    const ProtectedAuth = function () {
      return ProtectedRouteAuth(value.auth);
    };
    return (<Route element={< ProtectedAuth/>}>
      <Route key={key} path={value.path()} element={<value.element/>} />
    </Route>)
  });
  return (
    <ThemeProvider theme={Constants.DEFAULT_THEME}>
      <Routes>
        {/* ログインの必要がないルーティング */}
        {publicRoute}
        {/* ログインの必要があるルーティング */}
        {privateRoute}
      </Routes>
    </ThemeProvider>
  );

};

export default App;
